import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { ReturnRateOption } from "@redotech/redo-return-core-common/return-flow/condition-enums";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  returnRateFromModel,
  validateReturnRateCondition,
  type ReturnRateState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const RETURN_RATE = (
  Details: React.ComponentType<ConditionTypeDetailsProps<ReturnRateState>>,
): ConditionType<ReturnRateState, Condition.ReturnRate> => ({
  name: CONDITION_NAMES[Condition.RETURN_RATE],
  description(state) {
    if (!state.comparison) {
      return t("The percentage of orders this customer has returned");
    }
    switch (state.comparison) {
      case ReturnRateOption.LESS_THAN:
        return t("Customer return rate less than {{value}}", {
          value: state.returnRate,
        });
      case ReturnRateOption.GREATER_THAN:
        return t("Customer return rate greater than {{value}}", {
          value: state.returnRate,
        });
    }
  },
  Details(props: ConditionTypeDetailsProps<ReturnRateState>) {
    return React.createElement(Details, props);
  },
  empty: { returnRate: "0", comparison: null },
  fromModel(model) {
    return returnRateFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.RETURN_RATE,
      // Store as decimal
      returnRate: +state.returnRate / 100,
      comparison: state.comparison,
    };
  },
  valid(state) {
    return validateReturnRateCondition(state).valid;
  },
});
